// // import React, { useState } from 'react';
// // import axios from 'axios';

// // export default function YouTubeConnectButton({ tenantId }) {
// //   const [busy, setBusy] = useState(false);

// //   const connect = async () => {
// //     try {
// //       setBusy(true);
// //       const { data } = await axios.get(`/api/youtube/auth/url`, { params: { tenantId } });
// //       if (data?.url) window.location.href = data.url;
// //     } catch (e) {
// //       alert('Failed to start YouTube auth');
// //     } finally {
// //       setBusy(false);
// //     }
// //   };

// //   return (
// //     <button className="btn btn-primary" onClick={connect} disabled={busy}>
// //       {busy ? 'Connecting…' : 'Connect YouTube'}
// //     </button>
// //   );
// // }


// import React, { useState, useEffect } from 'react';

// const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://on-screen.app';

// export default function YouTubeConnectButton({ tenantId }) {
//   const [status, setStatus] = useState('disconnected'); // 'disconnected' | 'checking' | 'connected'
//   const [channelInfo, setChannelInfo] = useState(null);
//   const [loading, setLoading] = useState(false);

//   // Check if YouTube is already connected on mount
//   useEffect(() => {
//     if (!tenantId) return;
//     checkConnection();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [tenantId]);

//   async function checkConnection() {
//     try {
//       setStatus('checking');
//       const res = await fetch(`${BASE_URL}/api/youtube/me?tenantId=${tenantId}`);
//       const data = await res.json();
      
//       if (data.success && data.data?.items?.[0]) {
//         const channel = data.data.items[0];
//         setChannelInfo({
//           title: channel.snippet?.title,
//           id: channel.id,
//           subscriberCount: channel.statistics?.subscriberCount
//         });
//         setStatus('connected');
//       } else {
//         setStatus('disconnected');
//       }
//     } catch (err) {
//       console.error('YouTube connection check failed:', err);
//       setStatus('disconnected');
//     }
//   }

//   async function handleConnect() {
//     if (!tenantId) {
//       alert('Tenant ID is required');
//       return;
//     }

//     try {
//       setLoading(true);
      
//       // Get the OAuth URL from your backend
//       const res = await fetch(`${BASE_URL}/api/youtube/auth/url?tenantId=${tenantId}`);
//       const data = await res.json();
      
//       if (!data.success || !data.url) {
//         throw new Error('Failed to get YouTube auth URL');
//       }

//       // Open OAuth popup
//       const width = 600;
//       const height = 700;
//       const left = window.screen.width / 2 - width / 2;
//       const top = window.screen.height / 2 - height / 2;
      
//       const popup = window.open(
//         data.url,
//         'youtube_oauth',
//         `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,status=no`
//       );

//       if (!popup) {
//         alert('Popup blocked. Please allow popups for this site.');
//         return;
//       }

//       // Poll for popup close and check connection
//       const checkPopup = setInterval(() => {
//         if (popup.closed) {
//           clearInterval(checkPopup);
//           // Wait a moment for the backend to process the callback
//           setTimeout(() => {
//             checkConnection();
//           }, 1500);
//         }
//       }, 500);

//       popup.focus();
//     } catch (err) {
//       console.error('YouTube connect error:', err);
//       alert('Failed to connect to YouTube. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   }

//   if (status === 'checking') {
//     return (
//       <button type="button" className="btn btn-secondary" disabled>
//         Checking YouTube...
//       </button>
//     );
//   }

//   if (status === 'connected' && channelInfo) {
//     return (
//       <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//         <button type="button" className="btn btn-success" disabled>
//           ✓ YouTube Connected
//         </button>
//         <span style={{ fontSize: '13px', color: '#666' }}>
//           {channelInfo.title}
//           {channelInfo.subscriberCount && ` (${parseInt(channelInfo.subscriberCount).toLocaleString()} subscribers)`}
//         </span>
//         <button
//           type="button"
//           className="btn btn-sm btn-outline-secondary"
//           onClick={checkConnection}
//         >
//           Refresh
//         </button>
//       </div>
//     );
//   }

//   return (
//     <button
//       type="button"
//       className="btn btn-primary"
//       onClick={handleConnect}
//       disabled={loading || !tenantId}
//     >
//       {loading ? 'Connecting...' : 'YouTube'}
//     </button>
//   );
// }


import React, { useState, useEffect } from 'react';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://on-screen.app';

export default function YouTubeConnectButton({ tenantId }) {
  const [status, setStatus] = useState('disconnected'); // 'disconnected' | 'checking' | 'connected'
  const [channelInfo, setChannelInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  // Check if YouTube is already connected on mount
  useEffect(() => {
    if (!tenantId) return;
    checkConnection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);

  async function checkConnection() {
    try {
      setStatus('checking');
      const res = await fetch(`${BASE_URL}/api/youtube/me?tenantId=${tenantId}`);
      const data = await res.json();
      
      if (data.success && data.data?.items?.[0]) {
        const channel = data.data.items[0];
        setChannelInfo({
          title: channel.snippet?.title,
          id: channel.id,
          subscriberCount: channel.statistics?.subscriberCount
        });
        setStatus('connected');
      } else {
        setStatus('disconnected');
      }
    } catch (err) {
      console.error('YouTube connection check failed:', err);
      setStatus('disconnected');
    }
  }

  async function handleConnect() {
    if (!tenantId) {
      alert('Tenant ID is required');
      return;
    }

    try {
      setLoading(true);
      
      // Get the OAuth URL from your backend
      const res = await fetch(`${BASE_URL}/api/youtube/auth/url?tenantId=${tenantId}`);
      const data = await res.json();

      
      
      if (!data.success || !data.url) {
        throw new Error('Failed to get YouTube auth URL');
      }

      // Open OAuth popup
      const width = 600;
      const height = 700;
      const left = window.screen.width / 2 - width / 2;
      const top = window.screen.height / 2 - height / 2;
      
      const popup = window.open(
        data.url,
        'youtube_oauth',
        `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,status=no`
      );

      if (!popup) {
        alert('Popup blocked. Please allow popups for this site.');
        return;
      }

      // Poll for popup close and check connection
      const checkPopup = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkPopup);
          // Wait a moment for the backend to process the callback
          setTimeout(() => {
            checkConnection();
          }, 1500);
        }
      }, 500);

      popup.focus();
    } catch (err) {
      console.error('YouTube connect error:', err);
      alert('Failed to connect to YouTube. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  if (status === 'checking') {
    return (
      <button type="button" className="btn btn-secondary" disabled>
        Checking YouTube...
      </button>
    );
  }

  if (status === 'connected' && channelInfo) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <button type="button" className="btn btn-success" disabled>
          ✓ YouTube Connected
        </button>
        <span style={{ fontSize: '13px', color: '#666' }}>
          {channelInfo.title}
          {channelInfo.subscriberCount && ` (${parseInt(channelInfo.subscriberCount).toLocaleString()} subscribers)`}
        </span>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          onClick={checkConnection}
        >
          Refresh
        </button>
      </div>
    );
  }

  return (
    <button
      type="button"
      className="btn btn-primary"
      onClick={handleConnect}
      disabled={loading || !tenantId}
    >
      {loading ? 'Connecting...' : 'YouTube'}
    </button>
  );
}
